$(document).on('ajax:error', (e, data) => {
  let message = '';
  switch (data.status) {
    case 500:
      message = 'エラーが発生しました。';
      break;
    case 404:
      message = '該当のページは存在しない可能性があります。URLを再度確認してください。';
      break;
    case 401:
      message = 'エラーが発生しました。権限がありません。';
      break;
    default:
      message = 'エラーが発生しました。';
  }
  alert(message);
});
